// Turning an API failure into something worth showing a user.
//
// The backend reports field-validation failures through checkMissingKeys, which
// returns express-validator's own error OBJECTS ({ type, value, msg, path,
// location }) under `errors` — not strings. Spreading those straight into a
// toast renders "[object Object]", which is what a too-short reseller code used
// to produce on signup. Every call site that surfaces an API error goes through
// here so that cannot happen again, whichever shape the endpoint returns.

export function apiErrorMessages(payload) {
  if (!payload) return [];
  const messages = [];
  if (payload.message) messages.push(payload.message);
  if (Array.isArray(payload.errors)) {
    payload.errors.forEach((entry) => {
      if (typeof entry === "string") messages.push(entry);
      else if (entry && typeof entry === "object" && entry.msg) messages.push(entry.msg);
    });
  }
  // A generic `message` is often echoed by the per-field entries; showing it
  // twice reads like two separate problems.
  return [...new Set(messages.filter(Boolean))];
}

export function apiErrorMessage(error, fallback = "Something went wrong. Please try again.") {
  // No response at all means the request never landed — a server-side message
  // would be misleading.
  if (!error?.response) return "Unable to connect to the server. Please try again later.";
  const messages = apiErrorMessages(error.response.data);
  return messages.length ? messages.join(" ") : fallback;
}
